import { Box, FormControl } from '@primer/react';
import React from 'react';
import { Controller, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import TextInput from '../../../components/ui/text-input';
import { IHocSinh } from '../../../models/response/crm-hocsinh/IHocsinh';
import FormBlock from './FormBlock';
import ComboboxQuanHe from '../../../components/combobox-quanhe/ComboboxQuanHe';

interface IThongTinLienHeProps {
    control: any,
    hocSinh: IHocSinh,
    setFormData: React.Dispatch<React.SetStateAction<IHocSinh>>,
    setValue: UseFormSetValue<IHocSinh>,
    register: any,
    errors: any,
    formData: IHocSinh,
    trigger: UseFormTrigger<IHocSinh>,
}

const errorComboSx = {
    "& button": {
        borderColor: "danger.emphasis !important",
        boxShadow: "0 0 0 1px #cf222e",
    },
};

const requiredStar = <Box as="span" sx={{ color: "danger.fg" }}> *</Box>;

const ThongTinLienHe = (props: IThongTinLienHeProps) => {
    const { control, setFormData, hocSinh, register, errors } = props;
    const isRequireContact = Boolean(hocSinh.id === 0);
    const isLockedLeadParent = Boolean(hocSinh.id === 0 && hocSinh.crm_survey_respone_id);

    return (
        <FormBlock caption="Thông tin liên hệ">
            <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "repeat(4,1fr)" }}>
                <FormControl>
                    <FormControl.Label>Quan hệ{isRequireContact && requiredStar}</FormControl.Label>
                    <Controller
                        name="dm_quanhe_id"
                        control={control}
                        rules={isRequireContact ? {
                            required: "Vui lòng chọn quan hệ",
                            validate: (v: any) => Number(v) > 0 || "Vui lòng chọn quan hệ",
                        } : undefined}
                        render={({ field }) => (
                            <>
                                <Box sx={errors.dm_quanhe_id ? errorComboSx : undefined}>
                                    <ComboboxQuanHe
                                        value={field.value}
                                        onValueChanged={(value) => {
                                            field.onChange(value);
                                            setFormData((prev) => ({
                                                ...prev,
                                                dm_quanhe_id: value,
                                            }));
                                        }}
                                    />
                                </Box>
                                {errors.dm_quanhe_id && (
                                    <FormControl.Validation variant="error">
                                        {errors.dm_quanhe_id.message}
                                    </FormControl.Validation>
                                )}
                            </>
                        )}
                    />
                </FormControl>
                <FormControl>
                    <FormControl.Label>Họ tên{isRequireContact && requiredStar}</FormControl.Label>
                    <TextInput
                        block
                        name="ho_ten_lien_he"
                        register={register}
                        errors={errors}
                        disabled={isLockedLeadParent}
                        required={isRequireContact}
                        validateMessage="Vui lòng điền họ tên người liên hệ"
                    />
                </FormControl>
                <FormControl>
                    <FormControl.Label>Điện thoại{isRequireContact && requiredStar}</FormControl.Label>
                    <TextInput
                        block
                        name="dien_thoai_lien_he"
                        register={register}
                        errors={errors}
                        disabled={isLockedLeadParent}
                        required={isRequireContact}
                        validateMessage="Vui lòng điền số điện thoại liên hệ"
                    />
                </FormControl>
                <FormControl>
                    <FormControl.Label>Email</FormControl.Label>
                    <TextInput
                        block
                        name="email_lien_he"
                        register={register}
                        errors={errors}
                        disabled={isLockedLeadParent}
                    />
                </FormControl>
            </Box>
        </FormBlock>
    );
};

export default ThongTinLienHe;
